<template>
  <div class="login-default">
    <div class="login-default__title">
      {{loginConstants.LOGIN_DEFAULT_TITLE}}
    </div>
    <v-btn
        id="submit_login_btn"
        data-qe-id="submit_login_btn"
        color="ypo_blue"
        class="white--text"
        @click="initiateLoginWithOkta"
        large
        block>
      {{loginConstants.LOGIN}}
    </v-btn>
  </div>
</template>

<script>
    import { loginConstants } from './login.constants';
    import { mapActions } from 'vuex';
    import LoginError from './LoginError';
    import PrivacyPolicy from './PrivacyPolicy/PrivacyPolicy.vue';
    import 'firebase/messaging';
    import { storeAction } from "../../store/storeActions.constant";

    export default {
        name: 'LoginDefaultForm',
        components: { LoginError, PrivacyPolicy },
        props: {
            toggleProgressIndicator: Function,
            changeCardState: Function,
            isSubmitting: Boolean,
        },
        data: () => ({
            loginConstants,
        }),
        methods: {
          ...mapActions({
            initiateLoginRedirect: `auth/${storeAction.initiateLoginRedirect}`,
          }),
            initiateLoginWithOkta() {
              this.initiateLoginRedirect();
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '../../common/styles/_colors.scss';
    .login-default {
      margin-top: 40px;

      &__title {
        padding: 10px 0 20px;
        font-size: 15px;
        color: $black;
        opacity: 0.9;
        font-family: 'Noto Sans', sans-serif;
      }
      .submit {
        margin-top: 20px;
      }
    }
</style>
<style lang="scss">
</style>
